
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/createroom",
      function () {
        return require("private-next-pages/createroom.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/createroom"])
      });
    }
  